import { computed } from "nanostores";

import { getEntityClass, listEntityClasses } from "../api";
import { createPaginationStore } from "../stores/pagination.ts";
import { PaginationParams } from "../types/pagination.ts";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $entityClassesPagination = createPaginationStore();

const $paginationParamsString = computed(
  $entityClassesPagination.$paginationParams,
  (params) => JSON.stringify(params),
);

export const $entityClasses = createApiStore(listEntityClasses, {
  mapToOptions: ([paginationParamsString]) => {
    const paginationParams: PaginationParams = paginationParamsString
      ? JSON.parse(paginationParamsString)
      : { currentPage: 1, pageSize: 10 };

    return {
      query: {
        ...paginationParams,
      },
    };
  },
  params: [
    $paginationParamsString,
    computed($router, (route) => String(route?.route)),
  ],
  storeKey: "entityClasses",
});

export const $entityClass = createApiStore(getEntityClass, {
  mapToOptions: ([id]) => ({ path: { id } }),
  params: [
    computed($router, (route) => {
      if (!route?.params) return null;
      return "classId" in route.params ? route.params.classId : null;
    }),
  ],
  storeKey: "entityClass",
});
